import React from "react";
import {
  emphasize,
  makeStyles,
  useTheme,
  withStyles,
} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Chip from "@material-ui/core/Chip";
import HomeIcon from "@material-ui/icons/Home";
import { Box, Typography } from "@material-ui/core";
import { backGroundColor } from "../../../hoc/Layout/theme";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import stringLimiter from "../../../utility/String/stringLimiter";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    fontSize: 10,
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.grey[300],
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(Chip); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

function handleClick(event, $path, history) {
  // Router.push('/feed')
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    border: "1px solid #ebebeb",
    borderRadius: theme.borderSetRadius,
    marginBottom: theme.spacing(2),
  },
  avatar: {
    background: "none",
    marginRight: -theme.spacing(1.5),
  },
  home: {
    position: "relative",
    right: 0,
  },
  leftBorder: {
    borderRight: "3px solid " + backGroundColor,
    borderLeft: "3px solid " + backGroundColor,
    borderRadius: 5,
  },
}));

const showMobileView = (titleX, Ro) => {
  let title = titleX ? titleX : "خانه";
  return (
    <Wrapper>
      <Box
        display={"flex"}
        sx={{ width: "100%", cursor: "pointer" }}
        onClick={(e) => {
          // Ro.goBack()
        }}
      >
        <Box ml={2} pt={0.7}>
          <Typography variant={"caption"}>
            <span title={title}>{stringLimiter(title, 40)}</span>
          </Typography>
        </Box>

        {/*<Box flexGrow={1} css={{textAlign: "right", cursor: "pointer"}} pt={0.5}>*/}
        {/*    <LightTooltip title={"برگشت به صفحه قبل"}>*/}
        {/*        <ArrowBackIcon/>*/}
        {/*    </LightTooltip>*/}

        {/*</Box>*/}
      </Box>
    </Wrapper>
  );
};

const BreadcrumbsTemp = (props) => {
  const { items, title } = props;
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Paper elevation={0} className={classes.root}>
      <Box display={"flex"} mr={1} ml={1}>
        <Box className={classes.leftBorder}></Box>
        {!matches ? (
          <Wrapper>
            <Box ml={2} mt={0.5} pr={1}>
              <Typography variant={"caption"}>شما اینجا هستید :</Typography>
            </Box>
            <Box mt={0.5}>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={
                  <Box sx={{ fontSize: "10px", marginTop: 5 }}>
                    <ArrowBackIosIcon fontSize={"inherit"} />
                  </Box>
                }
              >
                <Link to={"/"}>
                  <StyledBreadcrumb
                    label="خانه"
                    icon={
                      <HomeIcon fontSize="small" className={classes.home} />
                    }
                  />
                </Link>

                {items
                  ? items.map((item) => {
                    if (Array.isArray(item) && item.length > 0) {
                      return (
                        <Breadcrumbs
                          key={item + 2}
                          aria-label="breadcrumb"
                          separator={"،"}
                        >
                          {item.map((it) => {
                            return (
                              <Link to={it.to} key={it.title}>
                                <StyledBreadcrumb
                                  title={it.title}
                                  label={stringLimiter(it.title, 50)}
                                />
                              </Link>
                            );
                          })}
                        </Breadcrumbs>
                      );
                    } else if (!Array.isArray(item)) {
                      return (
                        <Link key={item.title} to={item.to}>
                          <StyledBreadcrumb
                            title={item.title}
                            label={stringLimiter(item.title, 50)}
                          />
                        </Link>
                      );
                    }
                  })
                  : ""}
              </Breadcrumbs>
            </Box>
            {/*<Box flexGrow={1} css={{textAlign: "right"}} pt={0.5}>*/}

            {/*    <a onClick={e =>{*/}
            {/*        props.history.goBack()*/}
            {/*    }} title={"برگشت به صفحه قبل"}>*/}
            {/*        <ArrowBackIcon/>*/}
            {/*    </a>*/}

            {/*</Box>*/}
          </Wrapper>
        ) : (
          showMobileView(title, props.history)
        )}
      </Box>
    </Paper>
  );
};
export default withRouter(BreadcrumbsTemp);
